export class PerformanceCounter {
    Name: string;
    Timestamp: number;
    FormattedTimeStamp: string;
    Value: number;
    DisplayValue: string;
    IsDanger: boolean;
}